import { useEffect, useState } from "react";
import {
	AgreementInstallmentStatus,
	IAgreementInstallmentFlatRow,
	SinisterAgreementService,
} from "../../../shared/services/api/sinister/SinisterAgreementService";
import { NegotiationPaymentMethod } from "../../../shared/services/api/sinister/SinisterNegotiationService";

export type ICollectionControlRow = IAgreementInstallmentFlatRow;

export interface ICollectionControlFilters {
	filterField: "documento" | "nome" | "certificado";
	textSearch: string;
	installmentStatus: string;
	agreementStatus: string[];
	paymentMethod: string;
	clientName: string;
	dateType: "vencimento" | "pagamento";
	dataIni: string;
	dataFim: string;
}

// Consome GET /sinister-agreements/installments (contrato confirmado, ver
// PR-10-controle-cobranca-listagem-parcelas-frontend.md e MANUAL-BACKEND-ENDPOINTS-FRONTEND.md) —
// parcelas de todos os acordos já achatadas e paginadas pelo próprio backend, filtro/paginação deixam
// de ser client-side.
export function useCollectionControlInstallments(page: number, rowsPerPage: number, filters: ICollectionControlFilters) {
	const [rows, setRows] = useState<ICollectionControlRow[]>([]);
	const [totalCount, setTotalCount] = useState(0);
	const [isLoading, setIsLoading] = useState(true);
	const [error, setError] = useState<string | null>(null);
	const [refreshToken, setRefreshToken] = useState(0);

	const agreementStatusCsv = filters.agreementStatus.includes("Todos") ? undefined : filters.agreementStatus.join(",");

	useEffect(() => {
		let active = true;
		setIsLoading(true);
		setError(null);

		SinisterAgreementService.getInstallments({
			page: page + 1,
			limit: rowsPerPage,
			filterField: filters.filterField,
			textSearch: filters.textSearch,
			installmentStatus: filters.installmentStatus !== "Todos" ? (filters.installmentStatus as AgreementInstallmentStatus) : undefined,
			agreementStatusCsv,
			paymentMethod: filters.paymentMethod !== "Todos" ? (filters.paymentMethod as NegotiationPaymentMethod) : undefined,
			clientName: filters.clientName !== "Todos" ? filters.clientName : undefined,
			dateType: filters.dateType,
			dataIni: filters.dataIni,
			dataFim: filters.dataFim,
		}).then((result) => {
			if (!active) return;

			if (result instanceof Error) {
				setError(result.message);
				setRows([]);
				setTotalCount(0);
				setIsLoading(false);
				return;
			}

			setRows(result.data);
			setTotalCount(result.total);
			setIsLoading(false);
		});

		return () => {
			active = false;
		};
	}, [
		page,
		rowsPerPage,
		filters.filterField,
		filters.textSearch,
		filters.installmentStatus,
		agreementStatusCsv,
		filters.paymentMethod,
		filters.clientName,
		filters.dateType,
		filters.dataIni,
		filters.dataFim,
		refreshToken,
	]);

	return { rows, totalCount, isLoading, error, refetch: () => setRefreshToken((prev) => prev + 1) };
}
